import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=aa014dd8&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=aa014dd8&prod&lang=css"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=aa014dd8&prod&lang=scss&scoped=true"
import style2 from "./OrderDetails.vue?vue&type=style&index=2&id=aa014dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa014dd8",
  null
  
)

export default component.exports